(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-review-quote"] && !Shopify.designMode) return;
  try {
    
  /* Fills the quote slideshow from the Judge.me review widget already on the
     page. See the section's comment for why the DOM is read instead of calling
     the app's API.

     Only the reviews the widget has rendered are visible — its first page,
     normally five — so the slideshow covers that page rather than the full
     review history.

     Everything is defensive: cards without a rating or body are skipped, and if
     nothing usable turns up the card stays hidden and the app's widget is left
     alone, which is a working fallback rather than a blank space.

     Config arrives in data attributes because Liquid is not rendered inside
     javascript tags. */
  (function () {
    var TIMEOUT_MS = 10000;

    function textOf(node) {
      return node ? (node.textContent || "").replace(/\s+/g, " ").trim() : "";
    }

    // Reviews left on the website carry a Shop-app source; after-sales (email)
    // reviews do not. The section can hide low website reviews while keeping the
    // email ones. Read from the card so both the modal and the slideshow filter
    // the same way.
    function webMinRating() {
      var root = document.querySelector("[data-review-quote-source]");
      var v = root ? parseInt(root.getAttribute("data-web-min-rating"), 10) : 0;
      return isNaN(v) ? 0 : v;
    }

    function parseReviews(container) {
      var cards = container.querySelectorAll(".jdgm-rev");
      var out = [];
      var webMin = webMinRating();

      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var ratingEl = card.querySelector(".jdgm-rev__rating");
        var rating = ratingEl ? parseInt(ratingEl.getAttribute("data-score"), 10) : 0;
        var body = textOf(card.querySelector(".jdgm-rev__body"));
        if (!rating || !body) continue;

        // Drop low website (Shop-app) reviews; keep after-sales/email reviews,
        // which have no Shop-app source, at any rating.
        var srcEl = card.querySelector(".jdgm-rev__source");
        var src = srcEl ? srcEl.getAttribute("data-source") : "";
        if (webMin > 0 && src === "shop-app" && rating < webMin) continue;

        // Timestamp: data-content is a full "2026-07-09 17:22:42 UTC" string;
        // the visible text is the already-localised "07/09/2026". Prefer the
        // visible text, fall back to the date portion of data-content.
        var stampEl = card.querySelector(".jdgm-rev__timestamp");
        var date = textOf(stampEl);
        if (!date && stampEl) {
          date = (stampEl.getAttribute("data-content") || "").split(" ")[0];
        }

        // Photos: the thumbnail (~160px) for the grid, the link's href (~1024px)
        // for the full view. data-src covers the case where the widget is hidden
        // and its images have not lazy-loaded a real src yet.
        var images = [];
        var picLinks = card.querySelectorAll(".jdgm-rev__pics .jdgm-rev__pic-link");
        for (var p = 0; p < picLinks.length; p++) {
          var picImg = picLinks[p].querySelector("img");
          var thumb = picImg ? picImg.getAttribute("src") || picImg.getAttribute("data-src") : "";
          if (!thumb) continue;
          var full =
            picLinks[p].getAttribute("href") ||
            picLinks[p].getAttribute("data-mfp-src") ||
            thumb;
          images.push({ thumb: thumb, full: full });
        }

        out.push({
          rating: rating,
          body: body,
          title: textOf(card.querySelector(".jdgm-rev__title")),
          author: textOf(card.querySelector(".jdgm-rev__author")),
          verified: card.getAttribute("data-verified-buyer") === "true",
          date: date,
          images: images
        });
      }
      return out;
    }

    function select(reviews, minRating, pick, max) {
      var eligible = reviews.filter(function (r) {
        return r.rating >= minRating;
      });
      if (!eligible.length) return [];

      // The widget lists newest first, so document order is recency order.
      if (pick !== "newest") {
        eligible = eligible.slice().sort(function (a, b) {
          return b.body.length - a.body.length;
        });
      }
      return eligible.slice(0, max);
    }

    function fill(slide, review) {
      var textEl = slide.querySelector(".review-quote__text");
      var bylineEl = slide.querySelector(".review-quote__byline");

      if (textEl) textEl.textContent = review.body;
      if (bylineEl) {
        // Author, then a check badge + "Verified Buyer" for verified reviews —
        // matching the modal's review rows. No per-review stars.
        var html = escapeHtml(review.author || "Anonymous");
        if (review.verified) {
          html +=
            ' <span class="rq-vbadge"><svg width="8" height="8" viewBox="0 0 10 10" aria-hidden="true"><use href="#rqm-check"/></svg></span> Verified Buyer';
        }
        bylineEl.innerHTML = html;
      }
    }

    function buildDots(root, track, count) {
      var wrap = root.querySelector("[data-review-quote-dots]");
      if (!wrap || count < 2) return null;

      wrap.textContent = "";
      var dots = [];
      for (var i = 0; i < count; i++) {
        (function (index) {
          var dot = document.createElement("button");
          dot.type = "button";
          dot.className = "review-quote__dot" + (index === 0 ? " is-active" : "");
          dot.setAttribute("aria-label", "Review " + (index + 1) + " of " + count);
          dot.addEventListener("click", function () {
            track.scrollTo({ left: track.clientWidth * index, behavior: "smooth" });
          });
          wrap.appendChild(dot);
          dots.push(dot);
        })(i);
      }
      return dots;
    }

    function activate(root, track, slides, verifiedLabel, reviews, autoplayMs) {
      // Reuse the Liquid-rendered slide as the template for the rest.
      var template = slides[0];
      fill(template, reviews[0]);

      for (var i = 1; i < reviews.length; i++) {
        var clone = template.cloneNode(true);
        fill(clone, reviews[i]);
        track.appendChild(clone);
      }

      // var dots = buildDots(root, track, reviews.length);
      var current = 0;
      var stopped = false;

      function syncDots() {
        if (!dots || !track.clientWidth) return;
        var index = Math.round(track.scrollLeft / track.clientWidth);
        if (index === current) return;
        current = index;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle("is-active", i === current);
        }
      }

      track.addEventListener("scroll", syncDots, { passive: true });

      var reduced =
        window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (autoplayMs > 0 && reviews.length > 1 && !reduced) {
        var timer = setInterval(function () {
          if (stopped) return;
          var next = (current + 1) % reviews.length;
          track.scrollTo({ left: track.clientWidth * next, behavior: "smooth" });
        }, autoplayMs);

        // Once someone takes control, stop competing with them.
        ["pointerdown", "touchstart", "keydown"].forEach(function (evt) {
          root.addEventListener(
            evt,
            function () {
              stopped = true;
              clearInterval(timer);
            },
            { once: true, passive: true }
          );
        });
      }

      root.hidden = false;
    }

    /* Hiding the full list would leave "More reviews" pointing at something that
       isn't there, so the link becomes a reveal instead of a dead anchor: the
       widget is collapsed until asked for, then shown and scrolled to. The
       design's quote-then-full-list flow still holds, the page is just quieter
       until someone wants the detail.

       Done with an injected stylesheet rule rather than an inline style on the
       element. Judge.me keeps working on its widget after we hide it — it sets
       and clears inline styles of its own during setup — so an inline
       display:none gets wiped by the next re-render, and we have already
       disconnected the observer by then. A rule in a stylesheet survives that,
       and covers every match rather than only the first.

       Matched on href rather than a data attribute so a merchant-typed
       "#judgeme_product_reviews" keeps working, and any other link in the card
       is left alone. */
    /* One shared star path (design symbol #i-star), so summary and row stars
       are the same shape. escape() keeps text safe: it is inserted via innerHTML
       to build the design's exact markup. */
    var STAR_SPRITE =
      '<svg width="0" height="0" class="rq-sprite" aria-hidden="true" focusable="false">' +
      '<defs>' +
      '<symbol id="rqm-star" viewBox="0 0 24 24"><path d="M12 1.4L14.38 8.72H22.08L15.85 13.25L18.23 20.58L12 16.05L5.77 20.58L8.15 13.25L1.92 8.72H9.62Z"/></symbol>' +
      '<clipPath id="rqm-half"><rect x="0" y="0" width="12" height="24"/></clipPath>' +
      '<symbol id="rqm-x" viewBox="0 0 14 14"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.2" fill="none"/></symbol>' +
      '<symbol id="rqm-check" viewBox="0 0 10 10"><path d="M2 5.2 4.2 7.4 8 2.8" stroke="currentColor" stroke-width="1.4" fill="none"/></symbol>' +
      '</defs></svg>';

    // Inject the star sprite once, so both the inline summary and the modal can
    // reference #rqm-star without duplicating the symbols.
    function ensureSprite() {
      if (document.getElementById("rqm-star")) return;
      document.body.insertAdjacentHTML("beforeend", STAR_SPRITE);
    }

    function escapeHtml(str) {
      return String(str == null ? "" : str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function starsHtml(rating, smallClass) {
      // Whole + one half + empties. rating may be fractional (the summary
      // average); rows pass whole numbers.
      var full = Math.floor(rating);
      var frac = rating - full;
      var half = frac >= 0.25 && frac < 0.75;
      if (frac >= 0.75) full += 1;

      var cls = "rq-star" + (smallClass ? " rq-star--sm" : "");
      var out = '<span class="rq-stars">';
      for (var i = 0; i < 5; i++) {
        if (i < full) {
          out += '<svg class="' + cls + '" viewBox="0 0 24 24"><use href="#rqm-star"/></svg>';
        } else if (i === full && half) {
          out +=
            '<svg class="' + cls + '" viewBox="0 0 24 24">' +
            '<use href="#rqm-star" style="fill:var(--rqm-star-empty)"/>' +
            '<g clip-path="url(#rqm-half)"><use href="#rqm-star"/></g></svg>';
        } else {
          out += '<svg class="' + cls + '" viewBox="0 0 24 24"><use href="#rqm-star" style="fill:var(--rqm-star-empty)"/></svg>';
        }
      }
      return out + "</span>";
    }

    function reviewHtml(review) {
      var meta = '<span>' + escapeHtml(review.author || "Anonymous") + "</span>";
      meta +=
        '<span class="rq-vbadge"><svg width="8" height="8" viewBox="0 0 10 10"><use href="#rqm-check"/></svg></span>' +
        "<span>Verified Buyer</span>";
      if (review.date) meta += '<time class="rq-review__date">' + escapeHtml(review.date) + "</time>";

      var pics = "";
      if (review.images && review.images.length) {
        pics = '<div class="rq-review__pics">';
        for (var i = 0; i < review.images.length; i++) {
          // A real link to the full image: JS intercepts the click and opens the
          // lightbox, but with JS off (or if it fails) the href still opens the
          // photo in a new tab.
          pics +=
            '<a class="rq-review__pic" href="' + escapeHtml(review.images[i].full) + '"' +
            ' target="_blank" rel="noopener nofollow">' +
            '<img src="' + escapeHtml(review.images[i].thumb) + '" alt="Customer photo" loading="lazy">' +
            "</a>";
        }
        pics += "</div>";
      }

      return (
        '<article class="rq-review">' +
        starsHtml(review.rating, true) +
        (review.title ? '<h4 class="rq-review__title">' + escapeHtml(review.title) + "</h4>" : "") +
        '<p class="rq-review__body">' + escapeHtml(review.body) + "</p>" +
        pics +
        '<div class="rq-review__meta">' + meta + "</div>" +
        "</article>"
      );
    }

    function summaryStats(source, reviews) {
      var widg = source.querySelector(".jdgm-rev-widg") || source;
      var avg = parseFloat(widg.getAttribute("data-average-rating"));
      var count = parseInt(widg.getAttribute("data-number-of-reviews"), 10);
      if (isNaN(avg) || avg <= 0) {
        // Fall back to what we can see.
        var sum = 0;
        for (var i = 0; i < reviews.length; i++) sum += reviews[i].rating;
        avg = reviews.length ? sum / reviews.length : 0;
      }
      if (isNaN(count) || count <= 0) count = reviews.length;
      return { avg: avg, count: count };
    }

    function buildModal(label) {
      ensureSprite();
      var modal = document.createElement("div");
      modal.className = "rq-modal";
      modal.setAttribute("role", "dialog");
      modal.setAttribute("aria-modal", "true");
      modal.setAttribute("aria-label", label);
      modal.hidden = true;
      modal.innerHTML =
        '<div class="rq-modal__backdrop" data-rq-close></div>' +
        '<div class="rq-modal__panel">' +
        '<div class="rq-modal__head">' +
        '<h3 class="rq-modal__title">' + escapeHtml(label) + "</h3>" +
        '<button type="button" class="rq-modal__close" data-rq-close aria-label="Close">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><use href="#rqm-x"/></svg>' +
        "</button>" +
        "</div>" +
        '<div class="rq-modal__summary">' +
        '<div class="rq-modal__score"><strong data-rq-avg></strong><span data-rq-summary-stars></span></div>' +
        '<p class="rq-modal__based" data-rq-based></p>' +
        "</div>" +
        '<div class="rq-modal__list" data-rq-list></div>' +
        '<div class="rq-modal__foot" data-rq-pagination hidden></div>' +
        "</div>";
      document.body.appendChild(modal);
      return modal;
    }

    function wireModal(modal, source) {
      var lastFocus = null;
      var pageObserver = null;

      function renderSummary() {
        var reviews = parseReviews(source);
        var stats = summaryStats(source, reviews);
        modal.querySelector("[data-rq-avg]").textContent = stats.avg.toFixed(1);
        modal.querySelector("[data-rq-summary-stars]").innerHTML = starsHtml(stats.avg, false);
        modal.querySelector("[data-rq-based]").textContent =
          "Based on " + stats.count + (stats.count === 1 ? " review" : " reviews");
      }

      function renderList() {
        var list = modal.querySelector("[data-rq-list]");
        list.innerHTML = parseReviews(source).map(reviewHtml).join("");
        list.scrollTop = 0;
      }

      /* Scroll lock. Keeping the page still under the modal is not only about
         the visitor's wheel here.

         Paging the widget scrolls the page: Judge.me fetches the new page, swaps
         its reviews in, then scrolls back to its own widget so you land on review
         1 (the widget and its first review carry tabindex="-1" for the same
         purpose). That widget is the hidden one behind the modal, so the page is
         dragged to it. Nothing shows while the modal covers the viewport — the
         visitor finds the page moved once they close.

         body { overflow: hidden } does not stop this. It makes the viewport
         non-user-scrollable, but programmatic scrolling still works, which is
         exactly what the widget is doing.

         Taking the body out of flow does stop it: the document is left with no
         scrollable range at all, so scrollIntoView, focus() and scrollTop writes
         have nothing to act on — whoever calls them and whenever. That last part
         is why this replaced an earlier attempt that restored the scroll position
         after each pagination click: any fixed window can be outlasted by a slow
         response, and this cannot. It also covers iOS Safari, where an overflow
         lock lets touch scrolling through. */
      var lockedAt = 0;

      function lockScroll() {
        lockedAt = window.pageYOffset;
        var style = document.body.style;
        style.setProperty("position", "fixed");
        // Holding the body at its negative scroll offset keeps the same part of
        // the page in view, so the lock is invisible.
        style.setProperty("top", -lockedAt + "px");
        style.setProperty("left", "0");
        style.setProperty("right", "0");
        style.setProperty("overflow", "hidden");
      }

      function unlockScroll() {
        var doc = document.documentElement;
        var behavior = doc.style.scrollBehavior;
        // Returning to the saved position has to be instant: an app stylesheet
        // with smooth scrolling on would animate the page back into place.
        doc.style.scrollBehavior = "auto";

        var style = document.body.style;
        style.removeProperty("position");
        style.removeProperty("top");
        style.removeProperty("left");
        style.removeProperty("right");
        style.removeProperty("overflow");

        // While locked the document sat at 0; put it back where it was.
        window.scrollTo(0, lockedAt);
        doc.style.scrollBehavior = behavior;
      }

      /* Mirror the widget's page links as our own buttons. Clicking one clicks
         the real (hidden) widget link, which fetches that page and replaces the
         widget's reviews; the observer below then re-renders our list and these
         buttons from the new state. The widget's own controls stay the single
         source of truth, so we never track page numbers ourselves.

         The links are <a> elements with no href and role="button", so the click
         runs their handler and nothing else. */
      function renderPagination() {
        var foot = modal.querySelector("[data-rq-pagination]");
        var pag = source.querySelector(".jdgm-paginate");
        var links = pag ? pag.querySelectorAll(".jdgm-paginate__page") : [];
        foot.textContent = "";

        var made = 0;
        for (var i = 0; i < links.length; i++) {
          (function (link) {
            // Skip the first/last jump arrows; keep numbers and prev/next.
            if (
              link.classList.contains("jdgm-paginate__first-page") ||
              link.classList.contains("jdgm-paginate__last-page")
            ) {
              return;
            }
            var isPrev = link.classList.contains("jdgm-paginate__prev-page");
            var isNext = link.classList.contains("jdgm-paginate__next-page");
            var lbl = isPrev ? "‹" : isNext ? "›" : (link.textContent || "").trim();
            if (!lbl) return;

            var btn = document.createElement("button");
            btn.type = "button";
            btn.className = "rq-page" + (link.classList.contains("jdgm-curt") ? " is-current" : "");
            btn.textContent = lbl;
            btn.addEventListener("click", function () {
              link.click();
            });
            foot.appendChild(btn);
            made++;
          })(links[i]);
        }
        // A single page (or none) needs no controls.
        foot.hidden = made <= 1;
      }

      function ensureObserver() {
        if (pageObserver || !window.MutationObserver) return;
        pageObserver = new MutationObserver(function () {
          if (modal.hidden) return;
          renderList();
          renderPagination();
        });
        pageObserver.observe(source, { childList: true, subtree: true });
      }

      /* Photo lightbox. Built lazily on the first photo click, shared across
         reviews. Navigates within the clicked review's photo set, which is why
         the counter reads "1 / 2" rather than a running total. */
      var lightbox = null;
      var lb = { items: [], index: 0 };

      function buildLightbox() {
        var el = document.createElement("div");
        el.className = "rq-lightbox";
        el.setAttribute("role", "dialog");
        el.setAttribute("aria-modal", "true");
        el.setAttribute("aria-label", "Review photo");
        el.hidden = true;
        el.innerHTML =
          '<div class="rq-lightbox__backdrop" data-rq-lb-close></div>' +
          '<button type="button" class="rq-lightbox__close" data-rq-lb-close aria-label="Close">' +
          '<svg width="16" height="16" viewBox="0 0 14 14" aria-hidden="true"><use href="#rqm-x"/></svg>' +
          "</button>" +
          '<button type="button" class="rq-lightbox__nav rq-lightbox__nav--prev" data-rq-lb-step="-1" aria-label="Previous photo">‹</button>' +
          '<img class="rq-lightbox__img" alt="Customer photo">' +
          '<button type="button" class="rq-lightbox__nav rq-lightbox__nav--next" data-rq-lb-step="1" aria-label="Next photo">›</button>' +
          '<p class="rq-lightbox__counter"></p>';
        document.body.appendChild(el);

        el.addEventListener("click", function (event) {
          var step = event.target.closest ? event.target.closest("[data-rq-lb-step]") : null;
          if (step) {
            lbStep(parseInt(step.getAttribute("data-rq-lb-step"), 10));
            return;
          }
          if (event.target.closest && event.target.closest("[data-rq-lb-close]")) closeLightbox();
        });
        return el;
      }

      function showLightbox() {
        var multi = lb.items.length > 1;
        lightbox.querySelector(".rq-lightbox__img").src = lb.items[lb.index];
        var counter = lightbox.querySelector(".rq-lightbox__counter");
        counter.textContent = lb.index + 1 + " / " + lb.items.length;
        counter.hidden = !multi;
        lightbox.querySelector(".rq-lightbox__nav--prev").hidden = !multi;
        lightbox.querySelector(".rq-lightbox__nav--next").hidden = !multi;
      }

      function lbStep(delta) {
        var n = lb.items.length;
        lb.index = (lb.index + delta + n) % n;
        showLightbox();
      }

      function openLightbox(items, index) {
        if (!lightbox) lightbox = buildLightbox();
        lb.items = items;
        lb.index = index;
        showLightbox();
        lightbox.hidden = false;
        lightbox.querySelector(".rq-lightbox__close").focus();
      }

      function closeLightbox() {
        if (!lightbox) return;
        lightbox.hidden = true;
        // The modal is still open, so leave the body scroll lock in place.
        modal.querySelector(".rq-modal__close").focus();
      }

      function lightboxOpen() {
        return lightbox && !lightbox.hidden;
      }

      function close() {
        modal.hidden = true;
        unlockScroll();
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      function open() {
        lastFocus = document.activeElement;
        ensureObserver();
        renderSummary();
        renderList();
        renderPagination();
        modal.hidden = false;
        lockScroll();
        modal.querySelector(".rq-modal__close").focus();
      }

      modal.addEventListener("click", function (event) {
        var t = event.target;

        // Thumbnail → lightbox. Collect that review's photos so prev/next stay
        // within the set the customer clicked into.
        var pic = t && t.closest ? t.closest(".rq-review__pic") : null;
        if (pic) {
          event.preventDefault();
          var group = pic.parentNode.querySelectorAll(".rq-review__pic");
          var items = [];
          var index = 0;
          for (var i = 0; i < group.length; i++) {
            items.push(group[i].getAttribute("href"));
            if (group[i] === pic) index = i;
          }
          openLightbox(items, index);
          return;
        }

        if (t && t.hasAttribute && t.hasAttribute("data-rq-close")) close();
      });

      document.addEventListener("keydown", function (event) {
        // The lightbox sits above the modal, so it takes keys first.
        if (lightboxOpen()) {
          if (event.key === "Escape") closeLightbox();
          else if (event.key === "ArrowLeft" && lb.items.length > 1) lbStep(-1);
          else if (event.key === "ArrowRight" && lb.items.length > 1) lbStep(1);
          return;
        }
        if (event.key === "Escape" && !modal.hidden) close();
      });

      return open;
    }

    function setupSourceHiding(root, source, selector, behavior, label) {
      // Hide the app's widget on the page. In modal mode the widget stays hidden
      // and in place — the modal renders its own dark design from the widget's
      // reviews rather than showing the widget itself.
      var style = document.createElement("style");
      style.textContent = selector + "{height: 0 !important; overflow: hidden !important;}";
      document.head.appendChild(style);

      if (!source.id) return;

      // Reveal in place: emptying the rule works regardless of what the app has
      // done to the element in the meantime. Shared by the reveal behaviour and
      // by the modal's "Write a review", which needs the real widget visible.
      function reveal() {
        style.textContent = "";
        source.scrollIntoView({ behavior: "smooth", block: "start" });
      }

      var openModal = null;
      if (behavior === "modal") {
        openModal = wireModal(buildModal(label), source);
      }

      /* Delegated on document, not just this section's root, so any link to the
         widget anchor opens the reviews modal — the section's own "More reviews"
         link and the product-form rating badge alike.

         Capture phase, because the whole job of this handler is to cancel the
         fragment jump before the browser scrolls the page down to the (hidden)
         widget. In the bubble phase that only works if nothing between the link
         and the document calls stopPropagation first; on the document's capture
         phase we are the first handler on the path either way. Nothing else is
         affected — this ignores every link but the one to the widget. */
      document.addEventListener(
        "click",
        function (event) {
          var link = event.target && event.target.closest ? event.target.closest("a") : null;
          if (!link) return;
          if ((link.getAttribute("href") || "") !== "#" + source.id) return;

          event.preventDefault();
          if (openModal) {
            openModal();
          } else {
            reveal();
          }
        },
        true
      );
    }

    function attempt(root, source) {
      var track = root.querySelector("[data-review-quote-track]");
      var slides = root.querySelectorAll(".review-quote__slide");
      if (!track || !slides.length) return false;

      var reviews = select(
        parseReviews(source),
        parseInt(root.getAttribute("data-min-rating"), 10) || 1,
        root.getAttribute("data-pick") || "longest",
        parseInt(root.getAttribute("data-max-quotes"), 10) || 5
      );
      if (!reviews.length) return false;

      activate(
        root,
        track,
        slides,
        root.getAttribute("data-verified-label") || "",
        reviews,
        parseInt(root.getAttribute("data-autoplay"), 10) || 0
      );

      // Fill the average summary (score, stars, count) from the widget's totals.
      var summaryEl = root.querySelector("[data-rq-inline-summary]");
      var stats = summaryStats(source, reviews);
      if (summaryEl) {
        ensureSprite();
        var avgEl = root.querySelector("[data-rq-inline-avg]");
        var starsEl = root.querySelector("[data-rq-inline-stars]");
        var basedEl = root.querySelector("[data-rq-inline-based]");
        if (avgEl) avgEl.textContent = stats.avg.toFixed(1);
        if (starsEl) starsEl.innerHTML = starsHtml(stats.avg, false);
        if (basedEl) {
          basedEl.textContent =
            "Based on " + stats.count + (stats.count === 1 ? " review" : " reviews");
        }
        summaryEl.hidden = false;
      }

      // Fill any rating badges on the page (e.g. the product-form review_rating
      // block) with compact stars + count. They live outside this section, so
      // they are filled here rather than in the section's own markup.
      var badges = document.querySelectorAll("[data-review-quote-badge]");
      if (badges.length) {
        ensureSprite();
        for (var b = 0; b < badges.length; b++) {
          var badgeStars = badges[b].querySelector("[data-badge-stars]");
          var badgeCount = badges[b].querySelector("[data-badge-count]");
          if (badgeStars) badgeStars.innerHTML = starsHtml(stats.avg, true);
          if (badgeCount) {
            badgeCount.textContent =
              stats.count + (stats.count === 1 ? " review" : " reviews");
          }
          badges[b].hidden = false;
        }
      }

      // Hide the widget only now that there is something to show in its place,
      // so a parse failure degrades to the app's own layout.
      if (root.getAttribute("data-hide-source") === "1") {
        setupSourceHiding(
          root,
          source,
          root.getAttribute("data-source-selector") || "#judgeme_product_reviews",
          root.getAttribute("data-link-behavior") || "modal",
          root.getAttribute("data-modal-label") || "Customer reviews"
        );
      }
      return true;
    }

    function watch(root) {
      var selector = root.getAttribute("data-source-selector") || "#judgeme_product_reviews";
      var source = document.querySelector(selector);
      if (!source) return;

      if (attempt(root, source)) return;
      if (!window.MutationObserver) return;

      var observer = new MutationObserver(function () {
        if (attempt(root, source)) observer.disconnect();
      });
      observer.observe(source, { childList: true, subtree: true });

      // The widget may never render (no reviews, app error). Stop watching
      // rather than leave an observer running for the life of the page.
      setTimeout(function () {
        observer.disconnect();
      }, TIMEOUT_MS);
    }

    function init() {
      var roots = document.querySelectorAll("[data-review-quote-source]");
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].dataset.reviewQuoteWatching) continue;
        roots[i].dataset.reviewQuoteWatching = "1";
        watch(roots[i]);
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
